import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function eventReducer(state = initialState.clubs, action) {
  let newState;

  switch (action.type) {
    case types.LOAD_CLUBS:
      // For this example, just simulating a save by changing date modified.
      // In a real app using Redux, you might use redux-thunk and handle the async call in fuelSavingsActions.js
      return objectAssign({}, state, {loadingClubs: true});

    case types.LOAD_CLUBS_SUCCESS:
      newState = objectAssign({}, state, {loadingClubs: false});
      newState.clubList = action.clubList;
      newState.clubListUpdated = action.clubListUpdated;
      return newState;

    case types.LOAD_CLUB_DETAILS:
      newState = objectAssign({}, state, {loadingClubs: true});
      newState.clubDetails = initialState.clubs.clubDetails;
      newState.clubDetailsUpdated = Date.now();
      return newState;

    case types.LOAD_CLUB_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loadingClubs: false});
      newState.clubDetails = action.clubDetails;
      newState.clubDetailsUpdated = action.clubDetailsUpdated;
      return newState;

    case types.LOAD_CLUB_DETAILS_FAILURE:
      newState = objectAssign({}, state, {loadingClubs: false});
      newState.errors = action.errors;
      return newState;

    case types.LOAD_CLUB_MEMBERS:
      newState = objectAssign({}, state, {loadingMembers: true});
      newState.memberList = [];
      newState.memberListUpdated = Date.now();
      return newState;

    case types.LOAD_MEMBER_DETAILS:
      newState = objectAssign({}, state, {loadingMembers: true});
      newState.memberDetails = initialState.clubs.clubDetails;
      newState.memberDetailsUpdated = Date.now();
      return newState;

    case types.LOAD_CLUB_MEMBERS_SUCCESS:
      newState = objectAssign({}, state, {loadingMembers: false});
      newState.memberList = action.memberList;
      newState.memberListUpdated = action.memberListUpdated;
      return newState;

    case types.UPDATE_MEMBER_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loadingMembers: false});
      newState.memberList = action.memberList;
      newState.errors = {};
      newState.memberListUpdated = action.memberListUpdated;
      newState.memberDetails = action.memberDetails;
      newState.memberDetailsUpdated = action.memberDetailsUpdated;
      return newState;

    case types.CREATE_MEMBER_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loadingMembers: false});
      newState.memberList = action.memberList;
      newState.memberListUpdated = action.memberListUpdated;
      newState.memberDetails = action.memberDetails;
      newState.memberDetailsUpdated = action.memberDetailsUpdated;
      return newState;

    case types.LOAD_MEMBER_DETAILS_SUCCESS:
      newState = objectAssign({}, state, {loadingMembers: false});
      newState.memberDetails = action.memberDetails;
      newState.memberDetailsUpdated = action.memberDetailsUpdated;
      return newState;

    case types.LOAD_CLUB_MEMBERS_FAILURE:
      newState = objectAssign({}, state, {loadingMembers: false});
      newState.errors = action.errors;
      return newState;

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/clubReducer.js
 **/